import { h } from "preact";
import AccessDenied from "../../layouts/AccessDenied";
import useRestrictedAccess from "../../hooks/useRestrictedAccess";
import { CSSTransition } from "react-transition-group";


export default function AccessControl(props) {

    const { isLoading, hasRestrictedAccess } = useRestrictedAccess();

    return (
        <CSSTransition
            classNames="fx-transition"
            in={!isLoading}
            timeout={100}
            unmountOnExit
        >
            {
                isLoading ? (
                    <div className="fx-transition" />
                ) :
                hasRestrictedAccess ? (
                    <div className="fx-transition">
                        {props.children}
                    </div>
                ) : (
                    <div className="fx-transition">
                        <AccessDenied />
                    </div>
                )
            }
        </CSSTransition>
    );
}